export const dataHooks = {
  removeButton: 'tag-remove-button',
  text: 'tag-text',
  thumb: 'tag-thumb',
};

export const dataAttr = {
  SIZE: 'data-size',
  DISABLED: 'data-disabled',
  THEME: 'data-theme',
  HOVERABLE: 'data-hoverable',
  CLICKABLE: 'data-clickable',
};
